document.addEventListener("DOMContentLoaded", function () {
  const mountedDom = document.querySelector(".bm_top_product_div");
  const contentDom = document.querySelector(".bm_product_points")

  function addImageAndStyles() {
    const hasMounted = !!mountedDom.querySelector("img[alt='LoloyalLabel']")
    const contentNotNull = contentDom.textContent.trim() !== ""
    if (contentNotNull && !hasMounted) {
      const img = document.createElement("img");
      img.src = "https://static.loloyal.com/m/id/60976595185/1745571895.svg";
      img.alt = "LoloyalLabel";
      img.style.cssText = "margin-right:4px;width:24px;height:24px;";
      mountedDom.style.cssText = "display:inline-flex;align-items:center;margin-bottom:16px;padding:4px 8px;border-radius:6px;background:#fdf0f0;";
      contentDom.style.cssText = "color:#D02F25;";
      mountedDom.prepend(img);
      observer.disconnect();
    }
  }
  const observer = new MutationObserver(function(mutations) {
    addImageAndStyles();
  });
  
  const config = {
    childList: true,
    characterData: true,
    subtree: true
  };
  
  observer.observe(contentDom, config);
});